import React from "react"
import { Box, Skeleton, Typography } from "@mui/material"

import { AppAntSwitch, AppBasicTable } from "@components"
import { dateHomeColumn, searchesHomeColumn, sitesHomeColumn, usersHomeColumn } from "./columns"
import { useDateTable } from "Pages/Main/Home/@hooks"
import { dateUserTableData, isDateRangeLoading, userSiteTableData } from "Pages/Main/Home/@signals"


export default function SearchAnalyticsSummaryTable() {
	const { showDateTable, setShowDateTable } = useDateTable()

	if (isDateRangeLoading.value) return <Skeleton variant="rectangular" height={470}/>

	return <AppBasicTable
		data={showDateTable ? dateUserTableData?.value?.bookingDateUser : userSiteTableData.value}
		Components={{
			Title: () => <Box>
				<Typography variant="h6">
					{`Summary of searches per ${showDateTable ? "Date & User" : "User & Site"}`}
				</Typography>
				<AppAntSwitch
					sx={{ mt: .9 }}
					checked={showDateTable}
					onChange={setShowDateTable}
					falseText={"Site/Date"}
				/>
			</Box>
		}}
		cardProps={{
			headerProps: {
				sx: { height: 120 }
			}
		}}
		sx={{ height: 313 }}
		headers={[[
			{ label: showDateTable ? "Date" : "Name" },
			{ label: showDateTable ? "Name" : "Website" },
			{ label: "Searches" },
		]]}
		columns={showDateTable
			? [dateHomeColumn(), usersHomeColumn(), searchesHomeColumn()]
			: [usersHomeColumn(), sitesHomeColumn(), searchesHomeColumn()]}
		setHeaderCellProps={(_, idx) => ({
			sx: {
				width: 1 / 3,
				backgroundColor: 'primary.main',
				textAlign: idx !== 2 && "left !important"
			}
		})}
	/>
}